<template>
	<j-base-select
		:options="options"
		:value="computedValue"
		:allowSelectNothing="false"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import library from "../library.js"

export default {
	props: {
		for: String, // caseWhere || proposalWhere || offerWhere || policyWhereInput || endorsementWhereInput
		value: String,
		caseWhere: String,
		proposalWhere: String,
		offerWhere: String,
		policyWhereInput: String,
		endorsementWhereInput: String
	},

	components: {
		JBaseSelect
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		decideVariables() {
			const proposalsVariables = {
				caseWhere: { id: this.caseWhere }
			}

			const offersAndPoliciesVariables = {
				caseWhere: { id: this.caseWhere },
				proposalWhere: { id: this.proposalWhere }
			}

			const endorsementsVariables = {
				caseWhere: { id: this.caseWhere },
				proposalWhere: { id: this.proposalWhere },
				policyWhereInput: { id: this.policyWhereInput }
			}

			let variables =
				this.for === "proposalWhere"
					? proposalsVariables
					: this.for === "offerWhere"
					? offersAndPoliciesVariables
					: this.for === "policyWhereInput"
					? offersAndPoliciesVariables
					: this.for === "endorsementWhereInput"
					? endorsementsVariables
					: null

			return variables
		},

		async fetchOptions() {
			// avoid invoking function when not needed
			if (
				(this.for === "proposalWhere" && !this.caseWhere) ||
				(this.for === "offerWhere" && !this.proposalWhere) ||
				(this.for === "policyWhereInput" && !this.proposalWhere)
			)
				return

			let query = library?.find(lib => lib.type === this.for)?.query
			let variables = this.decideVariables()

			const res = await api({ query, variables })

			const resKey =
				this.for === "caseWhere"
					? res?.data?.cases?.list
					: this.for === "proposalWhere"
					? res?.data?.cases?.list?.[0]?.proposals
					: this.for === "offerWhere"
					? res?.data?.cases?.list?.[0]?.proposals?.[0]?.basket
					: this.for === "policyWhereInput"
					? res?.data?.cases?.list?.[0]?.proposals?.[0]?.policies
					: this.for === "endorsementWhereInput"
					? res?.data?.cases?.list?.[0]?.proposals?.[0]?.policies?.[0]
							?.endorsements
					: []

			this.options = resKey?.reverse()?.map(item => {
				const labelKey =
					this.for === "caseWhere"
						? `${item?.holder?.name} - ${item?.component?.name}`
						: this.for === "proposalWhere"
						? item?.proposalNumber
						: this.for === "offerWhere"
						? item?.offerNumber
						: this.for === "policyWhereInput"
						? item?.issuerNumber
						: this.for === "endorsementWhereInput"
						? item?.id
						: null
				return {
					name: labelKey,
					value: item.id
				}
			})
		}
	},

	computed: {
		computedValue() {
			return this.value
		}
	},

	created() {
		this.fetchOptions()
		this.options.push({ value: this.value, name: this.value })
	},

	watch: {
		caseWhere: {
			handler() {
				this.fetchOptions()
			}
		},
		proposalWhere: {
			handler() {
				this.fetchOptions()
			}
		},
		offerWhere: {
			handler() {
				this.fetchOptions()
			}
		},
		policyWhereInput: {
			handler() {
				this.fetchOptions()
			}
		},
		endorsementWhereInput: {
			handler() {
				this.fetchOptions()
			}
		}
	}
}
</script>
